<template>
  <div>
    <div class="header-wrapper-partnershop"></div>
    <div class="partnershop-info-wrapper">
      <div class="grid-x grid-padding-x">
        <div class="large-12 cell">
          <div class="ps-image partnershop-image" v-bind:style="{ backgroundImage: `url(${partnerShopInformation.image})`, backgroundPosition: 'center center', backgroundSize: '130px' }"></div>
          <h2>{{ displayFullName }}</h2>
          <div class="partnershop-infotext">{{ partnerShopInformation.short_description }}</div>
        </div>
        <div class="large-auto small-12 cell partnershop-contact" v-if="partnerShopInformation.phone.mobileNumber || partnerShopInformation.phone.telephoneNumber">
          <img :alt="vueTranslationStrings.phone"
               class="phone"
               v-bind:src="`${vueTranslationStrings.iconBasePath}/assets/images/phone-black.svg`">
          <a v-bind:href="`tel:${partnerShopInformation.phone.mobileNumber}`" v-if="partnerShopInformation.phone.mobileNumber">{{ partnerShopInformation.phone.mobileNumber }}</a>
          <br v-if="partnerShopInformation.phone.mobileNumber && partnerShopInformation.phone.telephoneNumber" />
          <a v-bind:href="`tel:${partnerShopInformation.phone.telephoneNumber}`" v-if="partnerShopInformation.phone.telephoneNumber">{{ partnerShopInformation.phone.telephoneNumber }}</a>
        </div>
        <div class="large-auto small-12 cell partnershop-contact">
          <a v-bind:href="`mailto:${partnerShopInformation.email}`">
            <img class="letter" v-bind:src="`${vueTranslationStrings.iconBasePath}/assets/images/letter.svg`"
                 :alt="vueTranslationStrings.sendMail">
            {{ vueTranslationStrings.sendMail }}
          </a>
        </div>
        <div class="large-auto small-12 cell partnershop-contact" v-if="showFindMe">
          <a href="#tome">
            <img class="pin" v-bind:src="`${vueTranslationStrings.iconBasePath}/assets/images/pin-black.svg`"
                 :alt="vueTranslationStrings.location">
            {{ vueTranslationStrings.findMe }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config';
  import FetchHelper from '../../helpers/FetchHelper';
  import PartnerShopMethods from "../../services/PartnerShopMethods";

  export default {
    data: function() {
      return {
        partnerShopInformation: {
          address: {
            city: null,
            country: null,
            latitude: null,
            longitude: null,
            postalCode: null,
            street: null,
            streetNumber: null,
          },
          company: null,
          email: null,
          firstname: null,
          lastname: null,
          image: null,
          long_description: null,
          phone: {
            mobile: {
              code: null,
              country: null,
              number: null,
              type: null,
            },
            mobileNumber: null,
            telephone: {
              code: null,
              country: null,
              number: null,
              type: null,
            },
            telephoneNumber: null,
          },
          short_description: null,
        },
        partnerShopName: location.hostname.split(`.`)[0],
        showFindMe: true,
        vueTranslationStrings: window.vuePartnerShopHeaderStrings,
      };
    },
    computed: {
      displayFullName: function() {
        if(this.partnerShopInformation.firstname && this.partnerShopInformation.lastname) { return `${this.partnerShopInformation.firstname} ${this.partnerShopInformation.lastname}`; }
        if(this.partnerShopInformation.company) { return this.partnerShopInformation.company; }
      },
      displayName: function() {
        if(this.partnerShopInformation.firstname) { return this.partnerShopInformation.firstname; }
        if(this.partnerShopInformation.company) { return this.partnerShopInformation.company; }
      },
    },
    methods: {
      fetchAddressInformation: async function() {
        this.partnerShopInformation = await PartnerShopMethods.getPartnerShopInformation();
        if(this.partnerShopInformation) {
          if(this.partnerShopInformation.phone.mobile && this.partnerShopInformation.phone.mobile.countryCode && this.partnerShopInformation.phone.mobile.dialingCode && this.partnerShopInformation.phone.mobile.number) {
            this.partnerShopInformation.phone.mobileNumber = `${this.partnerShopInformation.phone.mobile.countryCode} ${this.partnerShopInformation.phone.mobile.dialingCode} ${this.partnerShopInformation.phone.mobile.number}`;
          }
          if(this.partnerShopInformation.phone.telephone && this.partnerShopInformation.phone.telephone.countryCode && this.partnerShopInformation.phone.telephone.dialingCode && this.partnerShopInformation.phone.telephone.number) {
            this.partnerShopInformation.phone.telephoneNumber = `${this.partnerShopInformation.phone.telephone.countryCode} ${this.partnerShopInformation.phone.telephone.dialingCode} ${this.partnerShopInformation.phone.telephone.number}`;
          }

          // hide show find me area if no address is given
          if(!this.partnerShopInformation.address.latitude && !this.partnerShopInformation.address.longitude && !this.partnerShopInformation.address.country && !this.partnerShopInformation.address.postalCode && !this.partnerShopInformation.address.city && !this.partnerShopInformation.address.street && !this.partnerShopInformation.address.streetNumber) {
            this.showFindMe = false;
          }
        }
      },
    },
    mounted: function() {
      this.fetchAddressInformation();
      window.$swal = this.$swal;
    },
  }
</script>
